// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".satisfi_image {\n    padding: .6rem 0rem;\n    margin: 0;\n    position: relative;\n}\n\n.satisfi_image img {\n    width: 100%;\n    height: auto;\n    border-radius: var(--imageBorderRadius);\n}\n\n.satisfi_image img.satisfi_firefox-svg {\n    width: calc(var(--chatWidth, 359px) - 56px) !important;\n}\n", ""]);
// Exports
module.exports = exports;
